import makeRequest from '@jg/http-client';
import { Auth } from '@jg/auth';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import config from '../../config';
import { IAppState } from '../../types/state.d';
import pushToPage from './pushToPage';
import objectToString from '../../utils/objectToString';
import { ROUTES } from '../../consts';
import getEventExpiryDate from '../../utils/getEventExpiryDate';
import {
  createEventRequestMade,
  createEventRequestSuccess,
  createEventRequestError,
} from '../actionCreators/apiActions';
import logInfo from './logInfo';

type CreateConsumerEventArgs = {
  name: string;
  eventType: string;
  dateStart?: string;
};

export default ({
  name,
  eventType,
  dateStart = new Date().toISOString(),
}: CreateConsumerEventArgs) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
) => {
  const url = config.eventsAPI;
  const start = new Date(dateStart);
  const startDate = `\\/Date(${start.getTime()}+0000)\\/`; // eslint-disable-line 😱
  const expiryDate = `\\/Date(${getEventExpiryDate(dateStart)}+0000)\\/`; // eslint-disable-line 😱
  const body = objectToString({
    name,
    eventType,
    startDate,
    completionDate: startDate,
    expiryDate,
  });

  dispatch(createEventRequestMade());
  try {
    const response = await makeRequest(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body,
    });
    if (!response.ok) {
      throw new Error(response.statusText);
    }

    const { id } = await response.json();
    const eventData = { id, name, type: eventType };
    dispatch(createEventRequestSuccess(eventData));
    dispatch(pushToPage(ROUTES.FUNDRAISING_SETTINGS));
  } catch (error) {
    dispatch(createEventRequestError());
    dispatch(
      logInfo({
        error,
        url,
        requestBody: body,
      }),
    );
  }
};
